import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { OptionListBeforeSectionContainer, OptionListRoot, OptionListSearch, OptionListSearchContainer } from './style';
import { OPTION_LIST_CLASS_PREFIX } from './constants';
import { OptionListItem } from './OptionListItem';
import { useOptionList, useOptionListClassName } from './utils';
import { useComponentTheme } from '../../utils/hooks';
export var OptionList = function OptionList(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(OPTION_LIST_CLASS_PREFIX);

  var _useOptionList = useOptionList(props),
      rootProps = _useOptionList.rootProps,
      dropdownOptionItemProps = _useOptionList.dropdownOptionItemProps,
      selectAllItemProps = _useOptionList.selectAllItemProps,
      dropdownOptionListSearchProps = _useOptionList.dropdownOptionListSearchProps,
      internalOptions = _useOptionList.internalOptions,
      dynamicInternalOptions = _useOptionList.dynamicInternalOptions,
      disabled = _useOptionList.disabled,
      internalValue = _useOptionList.internalValue,
      enableSearchOption = _useOptionList.enableSearchOption,
      isOptionListHeaderRendered = _useOptionList.isOptionListHeaderRendered,
      isSelectAllOptionRendered = _useOptionList.isSelectAllOptionRendered;

  var classOverride = useOptionListClassName(OPTION_LIST_CLASS_PREFIX, className, disabled);

  var renderOptionItem = function renderOptionItem(item) {
    return React.createElement(OptionListItem, Object.assign({}, dropdownOptionItemProps(item), {
      theme: theme,
      className: "".concat(classOverride.Item, " ").concat(internalValue.includes(item.value) ? 'active' : '')
    }));
  };

  return internalOptions.length ? React.createElement(OptionListRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), isOptionListHeaderRendered && React.createElement(OptionListBeforeSectionContainer, {
    theme: theme,
    className: classOverride.BeforeSectionContainer
  }, enableSearchOption && React.createElement(OptionListSearchContainer, {
    theme: theme,
    className: classOverride.SearchContainer
  }, React.createElement(OptionListSearch, Object.assign({}, dropdownOptionListSearchProps, {
    theme: theme,
    className: classOverride.Search
  }))), isSelectAllOptionRendered && React.createElement(OptionListItem, Object.assign({}, selectAllItemProps, {
    theme: theme,
    className: classOverride.SelectAllItem
  }))), dynamicInternalOptions.map(renderOptionItem)) : null;
};